<template>
  <compare-tool
    ref="compareTool"
    :selectedComponent="selectedComponent"
    :chartTabContent="superChartTabContent"
    :chartData="chartData"
    :tooltipData="tooltipData"
    :tooltipDataProp="tooltipDataProp"
    :chartProperties="chartProperties"
    :compareGraphProp="compareGraphProp"
    :compareGraphOption="compareGraphOption"
    :compareGraphOwners="compareGraphOwners"
    :compareGraphOwner="compareGraphOwner"
    :projectionYear="projectionYear"
    :tooltipHeader="tooltipHeader"
    :pageHeadingInfo="pageHeadingInfo"
    :headers="headersdata"
    :rowsdata="rowsdata"
    :groupedRows="grouprow"
    :mainHeading="mainHeading"
    @onChangeChartTab="onChangeSuperChartTab"
    @onBack="onBack"
    @changeProjectionYear="changeEngagementCompareProjectionYear"
    @submit="applyFilter"
    @changeGraphPropOption="changeGraphPropOption"
    @changeGraphOwnerOption="changeGraphOwnerOption"
  ></compare-tool>
</template>
<script>
import {
  EngagementCompare,
  ICESuperIntegration,
  SuperannuationEngagementTool,
} from "../../mixin";
import { CompareTool } from "../../component/tool";
import SuperProjection from "../../models/superProjection";
import RiskProfile from "../../models/riskprofiles";
import _ from "lodash";
import {
  GET_COMPARE_SUPERANNUATIONS_INFO,
  SET_COMPARE_SUPERANNUATIONS_INFO,
  SET_LOADER_VISIBILITY,
  GET_RISK_PROFILE_DATA,
  GET_CLIENT_INFORMATION,
} from "../../helpers/vuex-constants";
import { CommonHelper } from "../../helpers";
import { mapActions, mapGetters } from "vuex";
import CompareGraph from "../../models/compareGraph";
import {
  DurationOption,
  EntityTypes,
  GrowthOption,
  SuperFundType,
  incomeExpenseGraphId,
  PensionOption,
  PensionOptionType,
  DefaultRetirementDate,
} from "../../helpers/constant";
export default {
  components: { CompareTool },
  computed: {
    ...mapGetters("superannuation", {
      getCompareSuperInfo: GET_COMPARE_SUPERANNUATIONS_INFO,
    }),
    ...mapGetters({
      getRiskProfileData: GET_RISK_PROFILE_DATA,
      getClientInformation: GET_CLIENT_INFORMATION,
    }),
    parentContainerWidth() {
      return this.$refs.compareTool.getScreenWidth();
    },
  },
  data() {
    return {
      compareSuperUserInput: [],
      superChartTabContent: [],
    };
  },
  async mounted() {
    this.compareGraphOwners = this.fillCompareSuperOwnerTypeDetails(
      this.getClientInformation
    );
    this.setGroupRows();
    this.compareModel();
    this.setChartTab();
    this.chartProperties = CompareGraph.getChartProperties();
    this.pageHeadingInfo.heading = "Compare different super instances";
    this.compareSuperUserInput = this.prepareSuperCompareModel(0);
    this.getScreenWidth();
    await this.getSuperProjectionData(this.projectionYear.Value);
  },

  beforeDestroy() {
    this.setCompareSuperInfo([]);
  },
  mixins: [
    EngagementCompare,
    ICESuperIntegration,
    SuperannuationEngagementTool,
  ],
  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    ...mapActions("superannuation", {
      setCompareSuperInfo: SET_COMPARE_SUPERANNUATIONS_INFO,
    }),
    getRetirementText(fund) {
      let texts = [];
      fund.ownerDetails.forEach((owner) => {
        if (
          this.getSelectedClients().filter(
            (m) => m.clientId == owner.clientId
          )[0]
        ) {
          let retirementDate = CommonHelper.getRetirementDate(
            this.getClientInformation.filter(
              (m) => m.clientId == owner.clientId
            )[0].dob,
            owner.retirementAge
          );
          texts.push({
            innerText:
              owner.retirementAge +
              " Y (" +
              retirementDate.toLocaleString("default", { month: "short" }) +
              " " +
              retirementDate.getFullYear() +
              ")",
          });
        }
      });
      return texts;
    },
    getAccumultionAndPensionReturn(fundDetails, fundTypeFor) {
      let texts = [];
      let totalPercetages = [];
      fundDetails
        .filter((m) => m.fundType == fundTypeFor)
        .forEach((fund) => {
          totalPercetages[fund.clientId] = fund.incomeRate + fund.growthRate;
        });
      const selectedClients = this.getSelectedClients();
      _.orderBy(this.getClientInformation, "entityType").forEach((client) => {
        if (selectedClients.filter((m) => m.clientId == client.clientId)[0]) {
          if (totalPercetages[client.clientId] != undefined)
            texts.push({
              innerText: totalPercetages[client.clientId] + "% ",
            });
        }
      });
      return texts;
    },
    getPensionPaymentAmountDetails(fundDetails) {
      let texts = [];
      const selectedClients = this.getSelectedClients();
      if (fundDetails) {
        selectedClients.forEach((client) => {
          let amount = 0;
          const fundDetailsForClient = fundDetails.filter(
            (m) => m.clientId == client.clientId
          );
          if (fundDetailsForClient) {
            fundDetailsForClient.forEach((fund) => {
              if (fund.pensionPayment) {
                amount += fund.pensionPayment ? fund.pensionPayment.amount : 0;

                texts.push({
                  heading: PensionOption.filter((m) =>
                    m.value == fund.pensionPayment.paymentType > 0
                      ? fund.pensionPayment.paymentType
                      : PensionOptionType.Minimum
                  )[0].text,
                  innerText:
                    fund.pensionPayment.paymentType == PensionOptionType.Other
                      ? CommonHelper.convertIntoCurrencyWithoutDecimal(amount) +
                        " " +
                        DurationOption.filter(
                          (m) => m.value == fund.pensionPayment.durationType
                        )[0].text +
                        " " +
                        GrowthOption.filter(
                          (m) => m.value == fund.pensionPayment.growthType
                        )[0].text
                      : CommonHelper.convertIntoCurrencyWithoutDecimal(amount),
                });
              }
            });
          }
        });
        return texts; //CommonHelper.convertIntoCurrencyWithoutDecimal(amount);
      } else {
        return [];
      }
    },
    getClientPartnerAge() {
      let text = "";

      const selectedClients = this.getSelectedClients();
      selectedClients.forEach((client, index) => {
        if (
          this.getClientInformation.filter(
            (m) => m.clientId == client.clientId
          )[0]
        ) {
          if (index == 1) {
            text += " / ";
          }
          let dob = this.getClientInformation.filter(
            (m) => m.clientId == client.clientId
          )[0].dob;
          text +=
            new Date().getFullYear() - new Date(dob).getFullYear() + " Y ";
        }
      });
      return text;
    },
    setChartTab() {
      this.superChartTabContent = this.chartTabContent;

      this.superChartTabContent.splice(1, 0, {
        text: "Income & Expense",
        id: incomeExpenseGraphId,
        active: false,
      });
    },

    fillDefaultData(superInstances) {
      superInstances.forEach((superInstance) => {
        if (
          superInstance.ownerDetails.filter(
            (m) =>
              m.clientId ==
              this.getClientInformation.filter(
                (m) => m.entityType == EntityTypes.client
              )[0].clientId
          )[0] == undefined
        ) {
          superInstance.ownerDetails.push({
            clientId: this.getClientInformation.filter(
              (m) => m.entityType == EntityTypes.client
            )[0].clientId,
            retirementAge: DefaultRetirementDate,
            superBalance: 0,
            totalIncome: 0,
            factTotalIncome: 0,
          });
        }
        if (
          this.getClientInformation.filter(
            (m) => m.entityType == EntityTypes.partner
          )[0] &&
          superInstance.ownerDetails.filter(
            (m) =>
              m.clientId ==
              this.getClientInformation.filter(
                (m) => m.entityType == EntityTypes.partner
              )[0].clientId
          )[0] == undefined
        ) {
          superInstance.ownerDetails.push({
            clientId: this.getClientInformation.filter(
              (m) => m.entityType == EntityTypes.partner
            )[0].clientId,
            retirementAge: DefaultRetirementDate,
            superBalance: 0,
            totalIncome: 0,
            factTotalIncome: 0,
          });
        }
      });
    },

    compareModel() {
      let data = this.getCompareSuperInfo;
      this.fillDefaultData(data);
      let Headers = [];
      let AdditionalRowVisible = false;
      let contributionDataVisible = false;
      let withdrawDataVisible = false;
      let marketCrashVisible = false;
      let returnVisible = false;
      let pensionpaymentVisible = false;
      let rows = {
        groupid1: {},
        groupid2: {},
      };

      Headers.push({
        text: "Include in Holistic",
        fieldName: "heading",
        switchRequied: false,
        style: {
          width: "230px",
        },
      });
      for (let i = 0; i < 5; i++) {
        if (i <= data.length - 1) {
          rows["groupid1"][data[i].superFundGuid.toString()] = {
            age: this.getClientPartnerAge(data[i].ownerDetails),
            pension_payment_amount: this.getPensionPaymentAmountDetails(
              data[i].fundDetails
            ),
            retirement: this.getRetirementText(data[i]),
            age_pension:
              data[i].otherDetail && data[i].otherDetail.isAgePension
                ? "Yes"
                : "No",
            home_owner:
              data[i].otherDetail.isHomeOwner && data[i].otherDetail.isHomeOwner
                ? "Yes"
                : "No",
            accumulation_return: this.getAccumultionAndPensionReturn(
              data[i].fundDetails,
              SuperFundType.Accumulation
            ),
            pension_return: this.getAccumultionAndPensionReturn(
              data[i].fundDetails,
              SuperFundType.Pension
            ),
            expense: data[i].otherDetail
              ? CommonHelper.convertIntoCurrencyWithoutDecimal(
                  data[i].otherDetail.retirementExpenseBalance
                )
              : CommonHelper.convertIntoCurrencyWithoutDecimal(0),
            balance: CommonHelper.convertIntoCurrencyWithoutDecimal(
              this.getBalance(data[i])
            ),
            income: CommonHelper.convertIntoCurrencyWithoutDecimal(
              this.getIncome(data[i])
            ),
            nonsuper:
              data[i] && data[i].otherDetail
                ? CommonHelper.convertIntoCurrencyWithoutDecimal(
                    data[i].otherDetail.nonSuperBalance
                  )
                : CommonHelper.convertIntoCurrencyWithoutDecimal(0),
            employercontribution: this.getContributionAmount(
              data[i],
              "employerAmount",
              "employerDurationType",
              "employerGrowthType"
            ),
            salary_sacrifice_contribution: this.getContributionAmount(
              data[i],
              "salarySacrificeAmount",
              "salarySacrificeDurationType",
              "salarySacrificeGrowthType"
            ),
            non_concessional_contribution: this.getContributionAmount(
              data[i],
              "nonConcessionalAmount",
              "nonConcessionalDurationType",
              "nonConcessionalGrowthType"
            ),
          };

          const selectedClients = this.getSelectedClients();
          selectedClients.push({ clientId: 0, clientName: "" });
          let additionalData = [];
          let contributionData = [];
          let withdrawalData = [];
          let marketCrashData = [];
          let pensionpaymentData = [];
          if (data[i].superAddtionalDetails != null) {
            selectedClients.forEach((client) => {
              data[i].superAddtionalDetails
                .filter((m) => m.clientID == client.clientId)
                .map((r) => {
                  let p = {
                    label: null,
                    typeId: null,
                    data: [],
                  };

                  let startMonth =
                    !r.startDate || r.startDate == ""
                      ? r.startDate
                      : CommonHelper.getMonthName(
                          CommonHelper.getMonthfromMonthYear(r.startDate)
                        );

                  let startYear =
                    !r.startDate || r.startDate == ""
                      ? r.startDate
                      : CommonHelper.getYearfromMonthYear(r.startDate);
                  let endMonth =
                    !r.endDate || r.endDate == ""
                      ? r.endDate
                      : CommonHelper.getMonthName(
                          CommonHelper.getMonthfromMonthYear(r.endDate)
                        );
                  let endYear =
                    !r.endDate || r.endDate == ""
                      ? r.endDate
                      : CommonHelper.getYearfromMonthYear(r.endDate);

                  p.typeId = r.typeId;
                  if (r.description != undefined && r.description != "") {
                    p.label =
                      client && client.clientName && r.clientID !== 0
                        ? client.clientName + ": " + r.description
                        : r.description;
                  } else {
                    const clientName =
                      client && client.clientName && r.clientID !== 0
                        ? client.clientName + ": "
                        : "";
                    p.label =
                      clientName +
                      this.DescriptionAdditionalForm(
                        r.descriptionplaceholder,
                        r.typeId
                      );
                  }
                  if (r.typeId == 1 || r.typeId == 2) {
                    p.data[0] = `Income ${CommonHelper.convertAmountIntoDecimalFormat(
                      r.amount1
                    )}% Growth ${CommonHelper.convertAmountIntoDecimalFormat(
                      r.amount2
                    )}% Franking ${CommonHelper.convertAmountIntoDecimalFormat(
                      r.amount3
                    )}%`;
                    additionalData.push(p);
                  } else if (
                    r.typeId == 3 ||
                    r.typeId == 4 ||
                    r.typeId == 5 ||
                    r.typeId == 6 ||
                    r.typeId == 7
                  ) {
                    if (r.typeId == 6) {
                      p.typeId = 3;
                      p.data[0] = r.amount1 + "%";
                    } else {
                      p.data[0] = `${CommonHelper.convertIntoCurrencyWithoutDecimal(
                        r.amount1
                      )}`;
                    }
                  }
                  // if (r.typeId != 4) {
                  p.data[1] = `${startMonth}
            ${startYear} ${endMonth ? "-" : ""} ${endMonth}
            ${endYear}`;

                  // }

                  if (r.typeId == 3) contributionData.push(p);
                  if (r.typeId == 4 || r.typeId == 5) {
                    withdrawalData.push(p);
                  }
                  if (r.typeId == 7) {
                    pensionpaymentData.push(p);
                  }
                  if (r.typeId == 6) {
                    marketCrashData.push(p);
                  }
                });
            });
          }
          // if (!AdditionalRowVisible) {
          AdditionalRowVisible = AdditionalRowVisible
            ? AdditionalRowVisible
            : additionalData.length > 0 ||
              contributionData.length > 0 ||
              withdrawalData.length > 0 ||
              marketCrashData.length > 0 ||
              pensionpaymentData.length > 0;
          returnVisible = returnVisible ? true : additionalData.length > 0;
          contributionDataVisible = contributionDataVisible
            ? true
            : contributionData.length > 0;
          withdrawDataVisible = withdrawDataVisible
            ? true
            : withdrawalData.length > 0;
          marketCrashVisible = marketCrashVisible
            ? true
            : marketCrashData.length > 0;
          pensionpaymentVisible = pensionpaymentVisible
            ? true
            : pensionpaymentData.length > 0;

          // }
          rows["groupid2"][data[i].superFundGuid.toString()] = {
            return: { listdata: additionalData },
            contribution: { listdata: contributionData },
            withdrawls: { listdata: withdrawalData },
            marketcrash: { listdata: marketCrashData },
            pensionpayment: { listdata: pensionpaymentData },
            //  BaselineInterestRate: data[i].interestRate + "%",
          };

          Headers.push({
            text: data[i].superannuationName,
            fieldName: data[i].superFundGuid.toString(),
            switchRequied: true,
            colour: this.barColors[i],
          });
        } else {
          rows["groupid1"]["blank" + i] = {
            balance: "",
            income: "",
            nonsuper: "",
            employercontribution: "",
            salary_sacrifice_contribution: "",
            non_concessional_contribution: "",
          };

          const selectedClients = this.getSelectedClients();
          selectedClients.push({ clientId: 0, clientName: "" });
          let additionalData = [];
          let contributionData = [];
          let withdrawalData = [];
          let marketCrashData = [];
          let pensionpaymentData = [];

          rows["groupid2"]["blank" + i] = {
            return: { listdata: additionalData },
            contribution: { listdata: contributionData },
            withdrawls: { listdata: withdrawalData },
            marketcrash: { listdata: marketCrashData },
            pensionpayment: { listdata: pensionpaymentData },
            //  BaselineInterestRate: data[i].interestRate + "%",
          };

          Headers.push({
            text: "",
            fieldName: "blank" + i,
            switchRequied: true,
            colour: this.barColors[i],
          });
        }
      }
      this.headersdata = Headers;
      this.rowsdata = rows;
      this.grouprow.filter((x) => x.groupid == "groupid2")[0].visible =
        this.grouprow.filter((x) => x.groupid == "groupid2")[0].visible
          ? true
          : AdditionalRowVisible;

      this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[0].visible = this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[0].visible
        ? true
        : returnVisible;
      this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[1].visible = this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[1].visible
        ? true
        : contributionDataVisible;
      this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[2].visible = this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[2].visible
        ? true
        : withdrawDataVisible;
      this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[4].visible = this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[4].visible
        ? true
        : marketCrashVisible;
      this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[3].visible = this.grouprow.filter(
        (x) => x.groupid == "groupid2"
      )[0].columns[3].visible
        ? true
        : pensionpaymentVisible;
    },
    getContributionAmount(
      superInfo,
      propName,
      durationpropName,
      growthTypePropName
    ) {
      let texts = [];
      const selectedClients = this.getSelectedClients();
      if (superInfo.fundDetails) {
        selectedClients.forEach((client) => {
          let amount = 0;
          const fundDetails = superInfo.fundDetails.filter(
            (m) => m.clientId == client.clientId
          );
          if (fundDetails) {
            fundDetails.forEach((fund) => {
              // let baseAmount = fund.contribution
              //   ? fund.contribution[propName]
              //   : 0;
              // amount += CommonHelper.getAmountByDurationType(
              //   baseAmount,
              //   durationtype
              // );
              if (fund.contribution) {
                amount = fund.contribution ? fund.contribution[propName] : 0;

                texts.push({
                  innerText:
                    fund.contribution["isUseSGC"] &&
                    durationpropName == "employerDurationType"
                      ? "Default SGC"
                      : CommonHelper.convertIntoCurrencyWithoutDecimal(amount) +
                        " " +
                        DurationOption.filter(
                          (m) => m.value == fund.contribution[durationpropName]
                        )[0].text +
                        " " +
                        GrowthOption.filter(
                          (m) =>
                            m.value == fund.contribution[growthTypePropName]
                        )[0].text,
                });
              }
            });
          }
        });
        return texts; //CommonHelper.convertIntoCurrencyWithoutDecimal(amount);
      } else {
        return [];
      }
    },
    getSelectedClients() {
      const client = this.compareGraphOwners.filter((m) => m.entityType == 1)[0]
        ? this.compareGraphOwners.filter((m) => m.entityType == 1)[0]
        : undefined;
      const partner = this.compareGraphOwners.filter(
        (m) => m.entityType == 2
      )[0]
        ? this.compareGraphOwners.filter((m) => m.entityType == 2)[0]
        : undefined;
      const selectedClients = [];
      if (this.compareGraphOwner.entityType == 6) {
        selectedClients.push({
          clientId: client.value,
          clientName: client.text.trim(),
        });
        selectedClients.push({
          clientId: partner.value,
          clientName: partner.text.trim(),
        });
      } else {
        selectedClients.push({
          clientId: this.compareGraphOwners.filter(
            (m) => m.entityType == this.compareGraphOwner.entityType
          )[0].value,
          clientName: this.compareGraphOwners
            .filter((m) => m.entityType == this.compareGraphOwner.entityType)[0]
            .text.trim(),
        });
      }
      return selectedClients;
    },
    getBalance(superInfo) {
      const selectedClients = this.getSelectedClients();
      let balance = 0;
      selectedClients.forEach((client) => {
        balance += _.sumBy(
          superInfo.superAdvanceDetails.filter(
            (m) => m.clientId == client.clientId
          ),
          "superFundBalance"
        );
      });
      return balance;
    },
    getIncome(superInfo) {
      const selectedClients = this.getSelectedClients();
      let balance = 0;
      selectedClients.forEach((client) => {
        balance += _.sumBy(
          superInfo.ownerDetails.filter((m) => m.clientId == client.clientId),
          "totalIncome"
        );
      });
      return balance;
    },
    getClientPartnerLabel(extraSpaceRequired) {
      let clientPartnerNames = [];
      _.orderBy(
        this.getClientInformation.filter(
          (m) => m.entityType == 1 || m.entityType == 2
        ),
        "clientId"
      ).forEach((client) => {
        clientPartnerNames.push(client.firstName);
      });
      const selectedClients = this.getSelectedClients();
      let clientIds = [];
      selectedClients.forEach((m) => clientIds.push(m.clientId));

      if (clientIds.length > 1) {
        return (
          "<div style='margin-left:20px'> " +
          clientPartnerNames[0] +
          " " +
          (extraSpaceRequired ? "<br/>" : "") +
          " <br/> " +
          clientPartnerNames[1] +
          "</div>"
        );
      } else if (clientIds.length == 1) {
        return (
          "<div style='margin-left:20px'> " +
          this.getClientInformation.filter((m) => m.clientId == clientIds[0])[0]
            .firstName +
          " </div>"
        );
      }
    },
    setGroupRows() {
      this.grouprow = [
        {
          heading: "Key Details",
          expanded: true,
          visible: true,
          groupid: "groupid1",
          columns: [
            {
              text: "Age",
              name: "age",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Income",
              name: "income",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Retirement " + this.getClientPartnerLabel(),
              name: "retirement",
              type: "multiline",
              style: {
                width: "230px",
              },
            },
            {
              text: "Expense",
              name: "expense",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Age Pension",
              name: "age_pension",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Home Owner",
              name: "home_owner",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Superannuation Balance",
              name: "balance",
              type: "String",
              style: {
                width: "230px",
              },
            },
            {
              text: "Employer Contribution " + this.getClientPartnerLabel(),
              name: "employercontribution",
              type: "multiline",
              style: {
                width: "230px",
              },
            },
            {
              text:
                "Salary Sacrifice Contribution " + this.getClientPartnerLabel(),
              name: "salary_sacrifice_contribution",
              type: "multiline",
              style: {
                width: "230px",
              },
            },
            {
              text:
                "Non Concessional Contribution " + this.getClientPartnerLabel(),
              name: "non_concessional_contribution",
              type: "multiline",
              style: {
                width: "230px",
              },
            },
            {
              text:
                "Pension Payment Amount  " + this.getClientPartnerLabel(true),
              name: "pension_payment_amount",
              type: "multilinewithheader",
              style: {
                width: "230px",
              },
            },
            {
              text: "Accumulation Return " + this.getClientPartnerLabel(),
              name: "accumulation_return",
              type: "multiline",
              style: {
                width: "230px",
              },
            },
            {
              text: "Pension Return " + this.getClientPartnerLabel(),
              name: "pension_return",
              type: "multiline",
              style: {
                width: "230px",
              },
            },
            // ,
            // {
            //   text: "Non-Super",
            //   name: "nonsuper",
            //   type: "String",
            //   style: {
            //     width: "230px",
            //   },
            // },
          ],
        },
        {
          heading: "Return",
          expanded: true,
          visible: false,
          groupid: "groupid2",
          style: {
            width: "230px",
          },

          columns: [
            {
              visible: false,
              text: "Return",
              name: "return",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            {
              visible: false,
              text: "Contribution",
              name: "contribution",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            {
              visible: false,
              text: "Withdrawals",
              name: "withdrawls",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            {
              visible: false,
              text: "Pension Payment",
              name: "pensionpayment",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
            {
              visible: false,
              text: "Maket Crash",
              name: "marketcrash",
              type: "DataList",
              style: {
                width: "230px",
              },
            },
          ],
        },
      ];
    },
    changeGraphPropOption(option) {
      this.chartData = [];
      this.compareGraphProp = option.name;
      this.refreshChart(
        option,
        this.projectionResult.superProjectionResult.length
      );
    },
    changeGraphOwnerOption(clientDetail) {
      this.compareGraphOwner = clientDetail;
      this.projectionResult = SuperProjection.setSuperProjections(
        this.iceApiResponse,
        this.compareSuperUserInput,
        clientDetail.entityType,
        clientDetail.value
      );
      this.onChangeSuperChartTab(this.selectedtabId);
      this.setGroupRows();
      this.compareModel();
    },

    async applyFilter() {
      this.chartData = [];
      if (this.projectionYear.Value > 0) {
        this.tooltipHeader = [];
        this.tooltipData = [];
        this.linetooltipData = [];
        this.xAxisArray = [];
        this.lineAxisArray = [];

        await this.getSuperProjectionData(this.projectionYear.Value);
      }
    },
    getProjectionYear() {
      let projectionYear = 0;
      let minlength = 0;
      let selectedIndex = -1;
      let data = CommonHelper.groupBy(
        "projectionYear",
        this.getCompareSuperInfo
      );
      for (let i = 0; i < data.length; i++) {
        if (data[i].length > minlength) {
          minlength = data[i].length;
          selectedIndex = i;
        }
      }
      if (minlength > 1) {
        projectionYear = data[selectedIndex][0].projectionYear;
      }
      return projectionYear;
    },
    prepareSuperCompareModel(projectionYear) {
      let compareModel = [];
      if (projectionYear == 0) {
        projectionYear = this.getProjectionYear();
        this.projectionYear.Value = projectionYear;
      }

      for (let i = 0; i < this.getCompareSuperInfo.length; i++) {
        if (
          projectionYear == 0 &&
          this.projectionYear.Value < this.getCompareSuperInfo[i].projectionYear
        ) {
          this.projectionYear.Value =
            this.getCompareSuperInfo[i].projectionYear;
        }
        compareModel.push({
          otherDetail: this.getCompareSuperInfo[i].otherDetail,
          ownerDetails: this.getCompareSuperInfo[i].ownerDetails,
          fundDetails: this.fillDefaultRiskProfile(
            this.getCompareSuperInfo[i].fundDetails
          ),
          superAddtionalDetails:
            this.getCompareSuperInfo[i].superAddtionalDetails,
          nonSuperData: this.getCompareSuperInfo[i].nonSuperData,
          superfundDetails: this.getCompareSuperInfo[i].superAdvanceDetails,
          name: this.getCompareSuperInfo[i].superannuationName,
          referenceGuid: CommonHelper.uuidv4(),
          projectionYear: this.getCompareSuperInfo[i].projectionYear,
          fileName: this.getCompareSuperInfo[i].s3FilePath,
        });
      }

      return compareModel;
    },

    fillDefaultRiskProfile(fundDetails) {
      let parentClientId = this.getClientInformation.filter(
        (sr) => sr.entityType == EntityTypes.client
      );
      for (let i = 0; i < fundDetails.length; i++) {
        if (fundDetails[i].riskProfileId == -1) {
          const riskProfile = RiskProfile.getRiskProfile(
            this.getRiskProfileData.defaultriskprofiles,
            0,
            fundDetails[i].clientId,
            fundDetails[i].clientId == parentClientId[0].clientId
              ? EntityTypes.client
              : EntityTypes.client
          );
          fundDetails[i].incomeRate = riskProfile.incomeRate;
          fundDetails[i].growthRate = riskProfile.growthRate;
          fundDetails[i].frankingRate = riskProfile.frankingRate;
        }
      }
      return fundDetails;
    },
    async getAllSuperData(projectionYear) {
      const promises = [];
      for (let i = 0; i < this.compareSuperUserInput.length; i++) {
        const payload = [];
        const fileName =
          this.compareSuperUserInput[i].projectionYear == projectionYear
            ? this.compareSuperUserInput[i].fileName
            : "";
        payload.push(this.compareSuperUserInput[i]);
        const projectionApiPayload = this.prepareAPIModel(payload);
        promises.push(this.getProjection(projectionApiPayload, fileName));
      }
      const response = await Promise.all(promises);
      return response;
    },

    setReferenceId(superCompareAPi, index, referenceGuid) {
      if (
        superCompareAPi.length > index &&
        superCompareAPi[index].incomeExpenseResult
      ) {
        for (
          let i = 0;
          i < superCompareAPi[index].incomeExpenseResult.length;
          i++
        ) {
          superCompareAPi[index].incomeExpenseResult[i].referenceGuid =
            referenceGuid;
        }
      }
    },
    resetAPiResponse(superCompareAPi) {
      this.compareSuperUserInput[0].referenceGuid =
        superCompareAPi[0].superAccumulationResult[0].referenceGuid;

      this.setReferenceId(
        superCompareAPi,
        0,
        this.compareSuperUserInput[0].referenceGuid
      );
      for (let i = 1; i < superCompareAPi.length; i++) {
        superCompareAPi[0].superAccumulationResult =
          superCompareAPi[0].superAccumulationResult.concat(
            superCompareAPi[i].superAccumulationResult
          );
        this.setReferenceId(
          superCompareAPi,
          i,
          superCompareAPi[i].superAccumulationResult[0].referenceGuid
        );
        superCompareAPi[0].incomeExpenseResult =
          superCompareAPi[0].incomeExpenseResult.concat(
            superCompareAPi[i].incomeExpenseResult
          );

        this.compareSuperUserInput[i].referenceGuid =
          superCompareAPi[i].superAccumulationResult[0].referenceGuid;

        superCompareAPi[0].superPensionResult =
          superCompareAPi[0].superPensionResult.concat(
            superCompareAPi[i].superPensionResult
          );
      }
      this.iceApiResponse = superCompareAPi[0];
    },
    async getSuperProjectionData(projectionYear) {
      this.setLoaderVisibility(true);
      let superCompareAPi = await this.getAllSuperData(projectionYear);
      this.setLoaderVisibility(false);
      this.resetAPiResponse(superCompareAPi);
      this.projectionResult = SuperProjection.setSuperProjections(
        this.iceApiResponse,
        this.compareSuperUserInput,
        this.compareGraphOwner.entityType,
        this.compareGraphOwner.value
      );

      this.startingYear =
        this.projectionResult.superProjectionResult[0].superProjection[0].year;
      this.xAxisMinValue = this.startingYear;
      this.onChangeSuperChartTab(this.selectedtabId);
    },
    addIncomeExpenseConfig() {
      this.compareOptionModel.incomeexpense = [
        {
          id: "inflow",
          name: "Inflow",

          toolTipPro: [
            {
              id: "inflow",
              name: "Inflow",
              isCurrencyType: true,
              isBold: true,
            },
            {
              id: "employmentIncome",
              name: "Income",
              isCurrencyType: true,
              isLMargin: true,
            },
            {
              id: "agePension",
              name: "Age Pension",
              isCurrencyType: true,
              isLMargin: true,
            },
            {
              id: "superPension",
              name: "Super Pension",
              isCurrencyType: true,
              isLMargin: true,
            },
            {
              id: "otherIncome",
              name: "Other Income",
              isCurrencyType: true,
              isLMargin: true,
            },
            {
              id: "graphTitle",
              name: "graphTitle",
              isCurrencyType: true,
              ishide: true,
            },
          ],
        },
        {
          id: "totalOutflow",
          name: "Outflow",
          toolTipPro: [
            {
              id: "totalOutflow",
              name: "Outflow",
              isCurrencyType: true,
              isBold: true,
            },
            {
              id: "expenses",
              name: "Expenses",
              isCurrencyType: true,
              isLMargin: true,
            },
            {
              id: "invContribution",
              name: "Inv Contributions",
              isCurrencyType: true,
              isLMargin: true,
            },
            {
              id: "superContribution",
              name: "Super Contributions",
              isCurrencyType: true,
              isLMargin: true,
            },
            {
              id: "graphTitle",
              name: "graphTitle",
              isCurrencyType: true,
              ishide: true,
            },
          ],
        },
        {
          id: "taxes",
          name: "Taxes",
          toolTipPro: [
            {
              id: "taxes",
              name: "Taxes",
              isCurrencyType: true,
              isBold: true,
            },
            {
              id: "graphTitle",
              name: "graphTitle",
              isCurrencyType: true,
              ishide: true,
            },
          ],
        },
        {
          id: "netCashFlow",
          name: "Net Cashflow",
          toolTipPro: [
            {
              id: "netCashFlow",
              name: "Net CashFlow",
              isCurrencyType: true,
              isBold: true,
            },
            {
              id: "graphTitle",
              name: "graphTitle",
              isCurrencyType: true,
              ishide: true,
            },
          ],
        },
      ];
    },
    addContributionConfig() {
      this.compareOptionModel.contributionWithdrawalGraph[0].toolTipPro = [
        {
          id: "contributionsAll",
          name: "Contributions",
          isCurrencyType: true,
        },
        {
          id: "employer",
          name: "Employer",
          isCurrencyType: true,
          isLMargin: true,
        },
        {
          id: "salarySacrifice",
          name: "Salary Sacrifice",
          isCurrencyType: true,
          isLMargin: true,
        },
        {
          id: "contributionsTax",
          name: "Contributions Tax",
          isCurrencyType: true,
          isLMargin: true,
        },
        {
          id: "nonContributionContribution",
          name: "Non Concessional",
          isCurrencyType: true,
          isLMargin: true,
        },
        {
          id: "contributionsAllCumulative",
          name: "Contributions (Cumulative)",
          isCurrencyType: true,
        },
        {
          id: "graphTitle",
          name: "graphTitle",
          isCurrencyType: true,
          ishide: true,
        },
      ];
    },
    onChangeSuperChartTab(tabId) {
      if (!this.compareOptionModel.incomeexpense) {
        this.addIncomeExpenseConfig();
        this.addContributionConfig();
      }
      this.onChangeChartTab(tabId);
      this.refreshChart(
        this.compareGraphOption[0],
        this.projectionResult.superProjectionResult.length
      );
    },

    refreshChartData(option, graphModel, width, isIncludeStartingPoint) {
      let toolTipBoxWidth =
        (this.projectionResult.superProjectionResult.length + 1) * 170;

      this.tooltipDataProp = CompareGraph.getChartToolTipPro(option);

      let data =
        incomeExpenseGraphId == this.selectedtabId
          ? this.projectionResult.incomeExpense
          : this.projectionResult.superProjectionResult;
      CompareGraph.fillGraphModel(
        graphModel,
        data,
        "superProjection",
        option.id,
        "openingBalance",
        option.toolTipPro,
        isIncludeStartingPoint
      );
      let graphPros = CompareGraph.getGraphLegends(
        data,
        data,
        "uniqueId",
        this.barColors,
        this.startingYear
      );
      this.resetChartModel(graphModel, graphPros, width, toolTipBoxWidth);
    },

    onBack() {
      this.$router.push({ name: "superannuation-instance-selection" });
    },
  },
};
</script>
<style lang="scss" module></style>
